import React from "react";

const dummyDashboard = [
  { title: "Active Shipments", value: 5 },
  { title: "Pending LC Requests", value: 2 },
  { title: "Products Listed", value: 12 },
  { title: "Non-conformances", value: 1 },
];

export default function SyntraMfgDashboardPage({ onClose }) {
  return (
    <div className="space-y-4">
      <h3 className="font-semibold text-gray-700">Dashboard (Dummy Data)</h3>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
        {dummyDashboard.map((d, idx) => (
          <div key={idx} className="border p-4 rounded-lg bg-gray-50 text-center">
            <p className="text-xl font-bold text-green-700">{d.value}</p>
            <p className="text-sm text-gray-500">{d.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
